export const dbCreation = (db: IDBDatabase) => {
  if (!db.objectStoreNames.contains("users")) {
    db.createObjectStore("users");
    const patientStore = db.createObjectStore("patients");
    patientStore.createIndex("byUser", "userId");
    const patientDataStore = db.createObjectStore("patientData");
    patientDataStore.createIndex("byPatient", ["userId", "patientId"]);
  }
};
